import type { MotifComponent, MotifComponentProps } from '../../motif';

export const snapBreakPrimaryVars: MotifComponentProps<MotifComponent.BREAK> = {
  '--break-total-desktop-height': '48px',
  '--break-half-desktop-height': '24px',
  '--break-total-mobile-height': '48px',
  '--break-half-mobile-height': '24px',
  '--break-shadow-light-color': 'transparent',
  '--break-shadow-dark-color': 'transparent',
};
